import service from '@/router/axios'

// 登录接口
export const loginByUsername = (data) => {
  return service({
    url: '/login',
    method: 'post',
    data
  })
}
// 修改密码接口
export const upPassword = (data) => {
  return service({
    url: '/update/password',
    method: 'put',
    data
  })
}
// 获取路由信息
export const getRouters = () => {
  return service({
    url: '/getRouters',
    method: 'get'
  })
}
export const logout = () => {
  return service({
    url: '/logout',
    method: 'get'
  })
}
